import type { Permit } from "$apis/parkito2/types.gen.ts";
import PermitGrantModel from "./PermitGrantModel.svelte.ts";

export default class PermitModel implements Permit {
  constructor(private permit: Permit) {}

  get capacity(): number {
    return this.permit.capacity;
  }
  get grants(): Array<PermitGrantModel> {
    return this.permit.grants.map((g) => new PermitGrantModel(g));
  }
  get id(): string {
    return this.permit.id;
  }

  grantsCount(): number {
    return this.permit.grants.length;
  }

  activeSessionCount(): number {
    return this.permit.grants.filter((g) => g.activeSession).length;
  }

  capacityLeft(): number {
    return this.capacity - this.activeSessionCount();
  }

  get autoRenewal() {
    return this.permit.autoRenewal;
  }

  get period() {
    return this.permit.period;
  }
}
